import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";

class AdmindashController {
  constructor($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
    this.name = "admindash";
    $localStorage.activeStateName = "admindash";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$timeout = $timeout;

    this.currentPageNumber = 1;
    this.jobbles = [];
    this.pages = [];

    this.remain_loading_count = 0;
    this.currentUser = this.$auth.getUserData();

    this.calculatePagination();

    var _this = this;
    // _this.remain_loading_count++;
    // _this.$auth.getAllJobbles(20).then(function(response) {
    //   _this.remain_loading_count--;
    //   console.log(response.data);
    //   _this.jobbles = response.data;
    // }, function(response) {
    //   _this.remain_loading_count--;
    //   console.log(response.data);
    // })

    _this.paginate(_this.currentPageNumber);

    $("adminsidebar .sidebar-nav li:nth-child(1)").removeClass().addClass("active");
  }

  calculatePagination() {
    // var numberOfEvents = Math.ceil(this.$auth.getUserData().company.totalNumberOfNonCloseEvents / 20);
    for (var i = 0; i < 3; i++) {
      this.pages.push(i + 1);
    }
  }

  paginate(pageNumber) {
    console.log("go to this page");

    if (pageNumber < 1 || pageNumber > this.pages.length) {
      return;
    }

    this.currentPageNumber = pageNumber;
    this.remain_loading_count++;
    this.jobbles = [];

    var companyId = this.currentUser.company.id;
    var offsetParam = pageNumber * 20 - 20,
      maxParam = 20,
      page = "live",
      sort = "lastUpdated",
      order = "desc";

    var _this = this;
    this.$auth.getAllJobbles(maxParam, offsetParam).then(
      function (data) {
        _this.jobbles = data.data;
        _this.jobbles.forEach(function (jobble) {
          jobble.startMonth = moment(jobble.dateCreated).format("MMM");
          jobble.startDay = moment(jobble.dateCreated).format("DD");
          for (var i = 0; i < jobble.companyLogoOtherUri.length; i++) {
            if (jobble.companyLogoOtherUri[i].indexOf("75x75") > -1) {
              jobble.companySmallLogoUri = jobble.companyLogoOtherUri[i];
              break;
            }
            if (jobble.companyLogoOtherUri[i].indexOf("160x160") > -1) {
              jobble.companyLargeLogoUri = jobble.companyLogoOtherUri[i];
            }
          }
          if (_this.$security.isUndefinedOrNull(jobble.companySmallLogoUri)) {
            jobble.companySmallLogoUri = jobble.companyLargeLogoUri;
          }
        });

        console.log(_this.jobbles);
        _this.remain_loading_count--;
      },
      function (data) {
        console.log(data);
        _this.jobbles = [];
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }
}

AdmindashController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];

export default AdmindashController;



// WEBPACK FOOTER //
// ./client/app/components/admindash/admindash.controller.js